import { objectToURLParams } from 'helpers/Utils';
import api from './api';

export const hydrate = parameters =>
  api.get(`/admin/gasStation/hydrate${objectToURLParams(parameters)}`);
